const isCartPage = window.location.pathname.includes("/cart");
if(isCartPage) {
  let counter = 0;
  let selector = "[name='checkout']";
  const interval = setInterval(() => {
      if (document.querySelector(selector)) {
          const style = document.createElement('style');
          style.innerHTML = `
              ${selector} {
                  opacity: 0.6 !important;
                  pointer-events: none !important;
              }
              .dynamic-cart-btns {
                display: none;
              }
          `;
          
          document.head.appendChild(style);
  
          setTimeout(() => {
              document.head.removeChild(style);
          }, 2000);
  
          clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) { 
              clearInterval(interval);
          }
      }
  }, 10);
  
}
document.addEventListener("BSS:changedCart", function(){
   const style = document.createElement('style');
    style.innerHTML = `
        [name='checkout'] {
            opacity: 0.6 !important;
            pointer-events: none !important;
        }
    `;
    document.head.appendChild(style);

    setTimeout(() => {
        document.head.removeChild(style);
    }, 4000);
    setTimeout(() => {
        BSS_B2B.observer.cartSubject.listenCartCheckout();
    }, 2000);
    
});

